import { Property } from '../../../types';
import { HealthIssue } from '../../../types/inventoryHealth';
import { isApartmentOrStudio } from './adminFeeRule';

export function checkElevatorFieldRule(property: Property): HealthIssue | null {
  if (!isApartmentOrStudio(property.tipoinmueble)) {
    return null;
  }

  const ascensor = property.ascensor;
  const isMissing =
    ascensor === null ||
    ascensor === undefined ||
    String(ascensor).trim() === '' ||
    String(ascensor).trim().toLowerCase() === 'null';

  if (isMissing) {
    return {
      ruleId: 'elevator_field',
      ruleName: 'Falta Campo Ascensor',
      severity: 'critical',
      message: 'Apartamento o apartaestudio sin confirmación de ascensor (campo vacío o no definido).',
      field: 'ascensor',
      currentValue: ascensor,
      suggestedFix: 'Definir si el edificio cuenta con ascensor (Sí / No).',
    };
  }

  return null;
}

export function checkHighFloorElevatorRule(property: Property): HealthIssue | null {
  if (!isApartmentOrStudio(property.tipoinmueble)) {
    return null;
  }

  const rawPiso = property.piso;
  const numPiso = typeof rawPiso === 'number' ? rawPiso : parseInt(String(rawPiso || '0'), 10);
  const ascensor = property.ascensor;

  if (numPiso >= 5 && (ascensor === 0 || (ascensor as any) === false)) {
    return {
      ruleId: 'high_floor_no_elevator',
      ruleName: 'Piso Alto (≥5) sin Ascensor',
      severity: 'warning',
      message: `Piso ${numPiso} registrado sin ascensor. Verificar si es acceso por escaleras para confirmación comercial.`,
      field: 'ascensor',
      currentValue: `Piso: ${numPiso}, Ascensor: No`,
      suggestedFix: 'Verificar con el propietario si el edificio realmente no cuenta con ascensor.',
    };
  }

  return null;
}
